export const SWITCH_BACK_NAV_REFRESH_KEY = 'SwitchBackFromNavRefresh2023';
export const ENABLE_NAV_REFRESH_NEW_KEY = 'EnableUxRefresh2026V2';
export const UNIVERSAL_CAMPAIGN_EXPERIENCE_ENABLED_KEY = 'UniversalCampaignExperienceEnabled';
